function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3146 6C13.3146 6.71797 12.7326 7.3 12.0146 7.3C11.2966 7.3 10.7146 6.71797 10.7146 6C10.7146 5.28203 11.2966 4.7 12.0146 4.7C12.7326 4.7 13.3146 5.28203 13.3146 6ZM12.8646 8.87788C14.1075 8.51137 15.0146 7.36162 15.0146 6C15.0146 4.34315 13.6715 3 12.0146 3C10.3578 3 9.01462 4.34315 9.01462 6C9.01462 7.36162 9.92174 8.51137 11.1646 8.87788V10H6.86462C6.39518 10 6.01462 10.3806 6.01462 10.85C6.01462 11.3194 6.39518 11.7 6.86462 11.7H11.1646L11.1646 19.2322C9.54478 18.971 8.17064 17.9758 7.39442 16.5986L8.08635 16.4132C8.31692 16.3514 8.38649 16.0582 8.20824 15.8994L6.02035 13.9507C5.85921 13.8071 5.60379 13.8756 5.536 14.0804L4.61561 16.862C4.54062 17.0887 4.7475 17.3078 4.97807 17.2461L5.71206 17.0494C6.84547 19.3877 9.24181 21 12.0147 21C14.7857 21 17.1806 19.3899 18.315 17.0543L19.0308 17.2461C19.2614 17.3078 19.4682 17.0887 19.3932 16.862L18.4728 14.0804C18.4051 13.8756 18.1496 13.8071 17.9885 13.9507L15.8006 15.8994C15.6224 16.0582 15.6919 16.3514 15.9225 16.4132L16.6323 16.6034C15.8556 17.9781 14.4827 18.9714 12.8646 19.2322L12.8646 11.7H17.1646C17.6341 11.7 18.0146 11.3194 18.0146 10.85C18.0146 10.3806 17.6341 10 17.1646 10H12.8646V8.87788Z",
  fill: "#06273A"
});

var SvgAnchor = function SvgAnchor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAnchor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/anchor.021b8c22.svg";
export { ForwardRef as ReactComponent };